import { useEffect, useRef } from 'react';
import useShortCode from './useShortCode';
import { toast } from '../components/ToastContainer/index.jsx';
import useRemoteConfig from './useRemoteConfig';
import useUser from './useUser';
import OrganisationService from '../services/organisation-service';

async function runRecalculationShortcut({
  shortCode,
  inflightRef,
  inflightKey,
  action,
  successMessage,
  errorMessage,
}) {
  if (!shortCode || inflightRef.current[inflightKey]) return;

  inflightRef.current[inflightKey] = true;
  try {
    await action(shortCode);
    toast.success(successMessage);
  } catch {
    toast.error(errorMessage);
  } finally {
    inflightRef.current[inflightKey] = false;
  }
}

function useKeyboardShortcuts() {
  const { emails } = useUser();
  const users = useRemoteConfig('keyboard_shortcuts');
  const shortCode = useShortCode();
  const inflightRef = useRef({ dso: false, customerReport: false });

  async function handleKeyboard(evt) {
    if (evt.altKey && evt.code === 'KeyC') {
      toast.success(`ShortCode copied!`);
      await navigator.clipboard.writeText(shortCode);
      evt.preventDefault();
    }

    if (evt.altKey && evt.code === 'KeyD') {
      evt.preventDefault();
      await runRecalculationShortcut({
        shortCode,
        inflightRef,
        inflightKey: 'dso',
        action: OrganisationService.calculateDSO,
        successMessage: 'DSO recalculation triggered!',
        errorMessage: 'Failed to trigger DSO recalculation',
      });
    }

    if (evt.altKey && evt.code === 'KeyR') {
      evt.preventDefault();
      await runRecalculationShortcut({
        shortCode,
        inflightRef,
        inflightKey: 'customerReport',
        action: OrganisationService.calculateCustomerReport,
        successMessage: 'Customer report recalculation triggered!',
        errorMessage: 'Failed to trigger customer report recalculation',
      });
    }
  }

  useEffect(() => {
    // Check if users is an array before calling includes
    if (!Array.isArray(users) || !users.includes(emails?.[0]?.address)) return;

    document.addEventListener('keydown', handleKeyboard);

    return () => {
      document.removeEventListener('keydown', handleKeyboard);
    };
  });
}

export default useKeyboardShortcuts;
